<script setup>
import { useSidebar } from '@/hooks/useSidebar'
import SideItem from './SideItem.vue'
import { useSidebarStore } from '@/stores/useSidebarStore'

const { filteredMenu, shouldRenderSidebar } = useSidebar()
const sidebarStore = useSidebarStore()
</script>

<template>
  <v-navigation-drawer
    v-if="shouldRenderSidebar"
    v-model="sidebarStore.sidebar_drawer"
    :rail="sidebarStore.mini_sidebar"
    permanent
  >
    <v-list aria-label="menu list" density="compact" nav>
      <template v-for="item in filteredMenu" :key="item.title">
        <SideItem :item="item" />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
